
import moment from 'moment'
import 'moment-timezone'
import objectPath from 'object-path'
import initialState from './initialState'

const mutations = {
  setFiltersPreset(state, preset) {
    state.form = {
      ...state.form,
      ...preset
    }
  },
  setField(state, { target, value }) {
    objectPath.set(state, target, value)
  },
  updateEditFormModal(state, payload) {
    state.editFormModal = {
      ...state.editFormModal,
      ...payload
    }
  },
  setEditForm(state, payload) {
    state.editForm = {
      ...state.editForm,
      ...payload,
      dateFrom: payload.dateFrom
        ? moment.tz(moment.unix(payload.dateFrom), 'Europe/Moscow').format('DD.MM.YYYY')
        : null,
      dateTo: moment.tz(moment.unix(payload.dateTo), 'Europe/Moscow').format('DD.MM.YYYY'),
      time: moment.tz(moment.unix(payload.dateTo), 'Europe/Moscow').format('HH:mm')
    }
  },
  clearEditForm(state) {
    state.editForm = initialState().editForm
    state.editFormErrors = []
  },
  updateParticipationFormModal(state, payload) {
    state.participationFormModal = {
      ...state.participationFormModal,
      ...payload
    }
  },
  clearParticipationForm(state) {
    state.participationForm = initialState().participationForm
    state.participationFormErrors = []
  },
  updateProgramModal(state, payload) {
    state.programModal = {
      ...state.programModal,
      ...payload
    }
  },
  setPagination(state, pagination) {
    state.pagination = pagination
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  setIsLoadingMore(state, isLoading) {
    state.setIsLoadingMore = isLoading
  },
  setIsContols(state, isControls) {
    state.isControls = isControls
  },
  setIsLoadingMoreBlocked(state, isBlocked) {
    state.setIsLoadingMoreBlocked = isBlocked
  },
  setCollection(state, collection) {
    state.collection = collection
  },
  setHasError(state, hasError) {
    state.hasError = hasError
  },
  updateFiltersCollection(state, collection) {
    state.filtersCollection = {
      ...state.filtersCollection,
      ...collection
    }

    state.filtersCollection.locations = state.filtersCollection.locations
      .map(item => ({
        name: item,
        slug: item
      }))
  },
  updateCollection(state, collection) {
    state.collection = [
      ...state.collection,
      ...collection
    ]
  },
  setResponsibleUsers(state, payload) {
    state.responsibleUsers = payload
  },
  setInitialState(state) {
    this.state.events = {
      ...initialState()
    }
  },
}

export default mutations